import { createFileRoute } from '@tanstack/react-router'
import { FindJobsDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { useModalSlot } from '@/components/custom/modal-slot'
import FindJobsDialog from '@/routes/_app/-dialogs/find-jobs'

export const Route = createFileRoute('/@modal/jobs/find')({
  staticData: { slotScope: '/_app/jobs/_list' },
  pendingComponent: FindJobsDialogPending,
  component: FindJobsSlot,
})

function FindJobsSlot() {
  const slot = useModalSlot(Route)
  return <FindJobsDialog {...slot} />
}
